import { rem } from 'polished';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FieldArray, getFormValues, reduxForm } from 'redux-form';
import styled from 'styled-components';
import Button from '../../components/Button';
import { formatPrice, __ } from '../../utilities';
import {
  remainingPassengerCountSelector,
  ticketPricesForEachPassengerSelector,
  totalPriceSelector,
} from './selectors';
import renderTickets, { Total, TotalPrice, TotalText } from './subForm';
import validate from './validate';

export const FORM_NAME = 'passenger_form';

const ButtonWrapper = styled.div`
  margin-bottom: ${rem(50)};
  margin-top: ${rem(20)};
  display: flex;
  justify-content: center;
`;

class FieldArraysForm extends Component {
  render() {
    const {
      array: { push: apush },
      handleSubmit,
      totalPrice,
      remainingPassengerCount,
      onClickAddFavouritePassengers,
    } = this.props;

    return (
      <form onSubmit={handleSubmit}>
        <FieldArray name="passengers" component={renderTickets} />
        {remainingPassengerCount > 0 && (
          <ButtonWrapper>
            <Button
              type="button"
              basic
              primary
              onClick={e => {
                e.preventDefault();
                apush('passengers', {});
              }}
            >
              + {__('Pridať cestujúceho')}
            </Button>
            <Button
              type="button"
              basic
              primary
              onClick={onClickAddFavouritePassengers}
            >
              + {__('Pridať obľúbených cestujúcich')}
            </Button>
          </ButtonWrapper>
        )}
        <Total>
          <TotalText>{__('Spolu')}</TotalText>
          <TotalPrice style={{ fontSize: '1.5rem' }}>
            {formatPrice(totalPrice)}
          </TotalPrice>
        </Total>
      </form>
    );
  }
}

FieldArraysForm.propTypes = {
  onClickAddFavouritePassengers: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  array: PropTypes.shape({
    push: PropTypes.func.isRequired,
    remove: PropTypes.func.isRequired,
  }).isRequired,
  totalPrice: PropTypes.number.isRequired,
  remainingPassengerCount: PropTypes.number.isRequired,
};

const withReduxForm = reduxForm({
  form: FORM_NAME,
  validate,
  enableReinitialize: true,
  destroyOnUnmount: false,
})(FieldArraysForm);

const mapStateToProps = state => {
  return {
    totalPrice: totalPriceSelector(state),
    selectedTicketPrices: ticketPricesForEachPassengerSelector(state),
    passengerFormData: getFormValues(FORM_NAME)(state),
    remainingPassengerCount: remainingPassengerCountSelector(state),
  };
};

export default connect(mapStateToProps)(withReduxForm);



// WEBPACK FOOTER //
// ./src/containers/Passengers/form.js